export * from './AppleBlack';
export * from './AppleWhite';
export * from './GoogleBlack';
export * from './GoogleWhite';


// WEBPACK FOOTER //
// src/app/src/components/Badges/index.ts